import React from "react";
import {Rating} from "../../../controls";

function Texts({activity, showTitle, showRating}) {
  let title = showTitle ? <h1>{activity.title}</h1> : null
  let longParagraphs = (activity.longDescription || '')
    .split('\n')
    .filter(l => l.trim().length > 0) 
    .map((l, index) => <p className="long" key={index}>{l}</p>)
  

  const rating = showRating ? <Rating activity={activity} textMode="averageAndCount" hideIfNoRating={true} /> : null;
  return (
    <div className="c-activity-texts">
      {title}
      <p className="short">{activity.shortDescription}</p>
      <div className="rating">{rating}</div>
      {longParagraphs}
    </div>
  )
}

export default Texts